export const NAME = "BAPP";
export const IOS="https://apps.apple.com/us/app/bapp-qr/id6745604281?platform=iphone";
export const ANDROID="https://play.google.com/store/apps/details?id=com.ega65.bapp";
export const CLIENT_PHONE="+32 2 883 11 98";
export const CLIENT_EMAIL="info@bapp.be";
export const CLIENT_WEBSITE="www.bapp.be";
export const CLIENT_ADDRESS1="Imperiastraat, 6 ";
export const CLIENT_ADDRESS2="1930 Zaventem";
export const CLIENT_ADDRESS3="Belgium";
export const CLIENT_ADDRESS4="";
